/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { filterValidationErrorSchema } from './filterValidationErrorSchema';
import { jqlValidationResultSchema } from './jqlValidationResultSchema';

export const validateCustomFiltersResponseSchema = z.object({
  get filterErrors() {
    return z.array(filterValidationErrorSchema).nullish();
  },
  generatedJql: z.string().nullish(),
  isValid: z.boolean(),
  get jqlValidation() {
    return z.union([jqlValidationResultSchema, z.null()]).optional();
  },
});
